import { render, staticRenderFns } from "./RegisterItem.vue?vue&type=template&id=5e7bc616"
import script from "./RegisterItem.vue?vue&type=script&lang=js"
export * from "./RegisterItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e7bc616')) {
      api.createRecord('5e7bc616', component.options)
    } else {
      api.reload('5e7bc616', component.options)
    }
    module.hot.accept("./RegisterItem.vue?vue&type=template&id=5e7bc616", function () {
      api.rerender('5e7bc616', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/payment_export/RegisterItem.vue"
export default component.exports